// extracted by mini-css-extract-plugin
module.exports = {"parent":"field_parent__37ECx","area":"field_area__1eoIw","childrenList":"field_childrenList__fFy4s"};